const SUPPLIER_ROUTE = [
  {
    path: 'supplier/zf-report',
    name: 'SupplierZfReport',
    component: () => import('@/views/supplier/zfReport/index.vue'),
    meta: {
      title: '直发报告列表',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'supplier/zf-report-detail',
    name: 'SupplierZfReportDetail',
    component: () => import('@/views/supplier/zfReport/zfReportDetail.vue'),
    meta: {
      title: '直发报告详情',
      icon: '',
      keepAlive: false,
    },
  },
]
export default SUPPLIER_ROUTE
